import { originPositionFromFirstTee } from "@/features/radar/utils/origin-position-from-first-tee";

import type { ClientConfig } from "../types/client-config";
import { resolveDefaultRadar } from "./resolve-default-radar";

export const fillMapOriginFromDefaultRadar = (
  config: ClientConfig
): ClientConfig => {
  const defaultRadar = resolveDefaultRadar(
    config.radars,
    config.defaultRadarId
  );
  const originPosition = originPositionFromFirstTee(
    defaultRadar?.convertedCourseData
  );
  if (!originPosition) {
    return config;
  }

  return {
    ...config,
    golfCourseConfig: {
      maxBoundsBufferHorizontal:
        config.golfCourseConfig?.maxBoundsBufferHorizontal ?? 500,
      maxBoundsBufferVertical:
        config.golfCourseConfig?.maxBoundsBufferVertical ?? 500,
      ...config.golfCourseConfig,
      targetPinsConfig: {
        selectedTargetIds:
          config.golfCourseConfig?.targetPinsConfig?.selectedTargetIds ?? [],
        ...config.golfCourseConfig?.targetPinsConfig,
        originPosition,
      },
    },
  };
};
